import { lazy } from 'react';

import MinimalLayout from 'layout/MinimalLayout';
import Loadable from 'ui-component/Loadable';

const PublicOfferRequest = Loadable(lazy(() => import('views/r2m/PublicOfferRequest')));
const PublicOfferView = Loadable(lazy(() => import('views/r2m/PublicOfferView')));
const PublicRegistration = Loadable(lazy(() => import('views/r2m/PublicRegistration')));

const PublicRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: '/h/:hotelSlug/request',
      element: <PublicOfferRequest />
    },
    {
      path: '/offer/:token',
      element: <PublicOfferView />
    },
    {
      path: '/register/complete/:token',
      element: <PublicRegistration />
    }
  ]
};

export default PublicRoutes;
